module.exports = __webpack_public_path__ + "static/img/top_up.e9550b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prizes/top_up.png
// module id = R7Ue
// module chunks = 1